import { render, staticRenderFns } from "./sixIcon.vue?vue&type=template&id=757b34dc&"
import script from "./sixIcon.vue?vue&type=script&lang=js&"
export * from "./sixIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports